
import { useSubscription } from '@/hooks/useSubscription';
import { useAuth } from '@/contexts/AuthContext';
import { useAdminStatus } from '@/hooks/useAdminStatus';

export const usePremiumAccess = () => {
  const { user } = useAuth();
  const { subscription, isSubscribed } = useSubscription();
  const { isAdmin, loading: adminLoading } = useAdminStatus();

  // hassaanabegam@gmail.com automatically gets premium access as admin
  const isAdminUser = user?.email === "hassaanabegam@gmail.com" || isAdmin;
  const isPremiumUser = isAdminUser || (isSubscribed && subscription?.subscription_tier === 'premium');
  
  const premiumFeatures = {
    // Teen/Student Premium Features
    careerMap360: isPremiumUser,
    dreamBoardPlus: isPremiumUser,
    teenFellowshipPrograms: isPremiumUser,
    pitchPlaygroundPro: isPremiumUser,
    monthlyMentorHours: isPremiumUser,
    shadowFounderExperience: isPremiumUser,
    verifiedSkillPortfolio: isPremiumUser,
    aiCareerCoach: isPremiumUser,
    communityLeaderBadge: isPremiumUser,
    earlyAccessEvents: isPremiumUser,
    
    // Startup Premium Features
    microInternshipProgram: isPremiumUser,
    startupNewsroomFeature: isPremiumUser,
    teenCommunityBuilding: isPremiumUser,
    courseCreatorAccess: isPremiumUser,
    talentMatchVerified: isPremiumUser,
    premiumOpportunityPosting: isPremiumUser,
    startupStoriesPublishing: isPremiumUser,
    inviteOnlyRoundtables: isPremiumUser,
    analyticsEngagement: isPremiumUser,
    teenMarketTesting: isPremiumUser,
    
    // Admin Features
    adminDashboard: isAdminUser,
    feedbackManagement: isAdminUser,
    userManagement: isAdminUser,
    contentModeration: isAdminUser,
    subscriptionManagement: isAdminUser,
    
    // Premium Dashboard Access - ONLY for premium users and admins
    premiumDashboardAccess: isPremiumUser
  };

  return {
    isPremiumUser,
    premiumFeatures,
    subscription,
    user,
    isAdmin: isAdminUser,
    adminLoading
  };
};
